import { createContext, useContext } from 'react'
import type { Session, User } from '../lib/gotrueTypes'
import type { AccountStatus } from '../api/auth'

export interface AuthContextValue {
  session: Session | null
  user: User | null
  isLoading: boolean
  isAuthenticated: boolean
  signInWithGoogle: () => Promise<void>
  signInWithFacebook: () => Promise<void>
  signInWithMagicLink: (email: string) => Promise<{ error: Error | null }>
  signOut: () => Promise<void>
  hasPasswordIdentity: boolean
  isSoftDeleted: boolean
  softDeleteStatus: AccountStatus | null
}

export const AuthContext = createContext<AuthContextValue | null>(null)

// Lives in this separate module (not AuthContext.tsx) so leaf hooks like
// useLibraryYDoc can read auth state without being broken by test files
// that vi.mock('../contexts/AuthContext'). Tests that mock AuthContext.tsx
// don't intercept this module, so useContext here returns the real value
// (which is `null` when no AuthProvider is mounted — i.e. unauthenticated).
export function useAuthOptional(): AuthContextValue | null {
  return useContext(AuthContext)
}
